import type { ApiOrg } from 'modules/listing/orgs/api/types/ApiOrg';

import { orgPresentListingTypes } from './orgPresentListingTypes';

export function orgHasListings(org: ApiOrg) {
  return orgPresentListingTypes(org).length > 0;
}
